import { Component } from '@angular/core';
import { ContextService } from 'projects/cross-study-portal-lib/src/public-api';
import { MenuOption } from '../../interfaces/menu-option';
import { MenuOptionService } from '../../services/menu-option.service';

@Component({
  selector: 'mcp-landing-page',
  templateUrl: './landing-page.component.html',
  styleUrls: ['./landing-page.component.scss'],
})
export class LandingPageComponent {
  private _title = 'webPageTitle';

  get menuOptions(): MenuOption[] {
    return this.menuOptionService.getMenuOptions();
  }

  constructor(private menuOptionService: MenuOptionService, private context: ContextService) {
  }

  get title(): string {
    return this._title;
  }

  isDirty(): boolean {
    return false;
  }

  public canAccessCards(): boolean {
    const isApiUser = this.context.instance?.isApiUser || false;
    const isLimitedUser = (!this.context.instance?.permissions ||
      this.context.instance?.permissions.length === 0);
    if (isApiUser || isLimitedUser) {
      return false;
    }
    return true;
  }
}
